import { useSettingsContext } from "../../../../../settings/context";
import { useDataTableContext } from "../../../context";

export function useGetProfileFromPreferences() {
  const { preferences } = useSettingsContext();
  const table = useDataTableContext();

  const tablePreference = preferences.get({
    key: table.tableId,
    version: table.version,
  });

  const profile = (
    tablePreference as {
      profile?: { id?: unknown; name?: unknown } | null;
    }
  )?.profile;

  const validProfile =
    typeof profile?.id === "string" &&
    profile.id.trim() !== "" &&
    typeof profile?.name === "string" &&
    profile.name.trim() !== ""
      ? { id: profile.id, name: profile.name }
      : undefined;

  return validProfile;
}
